import React from "react";
import LandingSection from "../components/LandingSection";
import Footer from "../components/Footer";

const PlacesForestService = () => {
  const parks = [
    {
      NAME: "Ashdown Gorge",
      "MANAGEMENT AREA": "Dixie National Forest",
      Address: "Brian Head, UT 84719, United States",
      "Phone No:": "435-865-3700",
      Website: "https://www.fs.usda.gov/recarea/dixie/recarea/?recid=24848",
      "Established on": "18 September 1984",
    },
    {
      NAME: "Box-Death Hollow Wilderness",
      "MANAGEMENT AREA": "Dixie National Forest",
      Address: "Escalante, UT 84726, United States",
      "Phone No:": "435-826-5499",
      Website: "https://www.fs.usda.gov/recarea/dixie/recarea/?recid=70912",
      "Established on": "18 September 1984",
    },
    {
      NAME: "Cottonwood Forest Wilderness",
      "MANAGEMENT AREA": "Dixie National Forest",
      Address: "Washington, UT 84780, United States",
      "Phone No:": "435-688-3246",
      Website: "https://wilderness.net/visit-wilderness/?ID=718",
      "Established on": "2009",
    },
    {
      NAME: "Dark Canyon Wilderness",
      "MANAGEMENT AREA": "Manti-La Sal National Forest",
      Address: "Monticello, UT 84535, United States",
      "Phone No:": "435-637-2817",
      Website:
        "https://www.fs.usda.gov/recarea/mantilasal/recarea/?recid=81864",
      "Established on": "18 September 1984",
    },
    {
      NAME: "Deseret Peak Wilderness",
      "MANAGEMENT AREA": "Uinta-Wasatch-Cache National Forest",
      Address: "Dugway, UT 84022, United States",
      "Phone No:": "435-843-4001",
      Website:
        "https://www.fs.usda.gov/detail/uwcnf/about-forest/districts/?cid=stelprdb5043523",
      "Established on": "18 September 1984",
    },
    {
      NAME: "High Uintas Wilderness",
      "MANAGEMENT AREA": "Ashley National Forest",
      Address: "North Duchesne, UT 84021, United States",
      "Phone No:": "435-738-1100",
      Website:
        "https://www.fs.usda.gov/detail/uwcnf/about-forest/districts/?cid=fsem_035477",
      "Established on": "18 September 1984",
    },
    {
      NAME: "Lone Peak Wildernesss",
      "MANAGEMENT AREA": "Uinta-Wasatch-Cache National Forest",
      Address: "Alpine, UT 84004, United States",
      "Phone No:": "801-733-2660",
      Website:
        "https://www.fs.usda.gov/detail/uwcnf/about-forest/districts/?cid=fsem_035453",
      "Established on": "24 February 1978",
    },
    {
      NAME: "Mount Naomi Wilderness",
      "MANAGEMENT AREA": "Uinta-Wasatch-Cache National Forest",
      Address: "Richmond, UT 84333, United States",
      "Phone No:": "435-755-3620",
      Website:
        "https://www.fs.usda.gov/detail/uwcnf/recreation/wintersports/?cid=fsem_035454",
      "Established on": "1984",
    },
    {
      NAME: "Mount Nebo Wilderness",
      "MANAGEMENT AREA": "Uinta-Wasatch-Cache National Forest",
      Address: "Nebo Loop Road Payson, UT 84651",
      "Phone No:": "435-623-2735",
      Website:
        "https://www.fs.usda.gov/detail/uwcnf/specialutah-places-to-visit/?cid=fsem_035455",
      "Established on": "1984",
    },
    {
      NAME: "Mount Olympus Wilderness",
      "MANAGEMENT AREA": "Uinta-Wasatch-Cache National Forest",
      Address: "Salt Lake City, UT 84109, United States",
      "Phone No:": "801-733-2660",
      Website:
        "https://www.fs.usda.gov/detail/uwcnf/about-forest/districts/?cid=fsem_035478",
      "Established on": "1984",
    },
    {
      NAME: "Mount Timpanogos Wilderness",
      "MANAGEMENT AREA": "Uinta-Wasatch-Cache National Forest",
      Address: "Provo, UT 84604, United States",
      "Phone No:": "801-785-3563",
      Website:
        "https://www.fs.usda.gov/detail/uwcnf/specialutah-places-to-visit/?cid=fsem_035456",
      "Established on": "18 September 1984",
    },
    {
      NAME: "Pine Valley Mountain Wilderness",
      "MANAGEMENT AREA": "Dixie National Forest",
      Address: "Washington County, Utah, United States",
      "Phone No:": "435-688-3246",
      Website: "https://wilderness.net/visit-wilderness/?ID=459",
      "Established on": "18 September 1984",
    },
    {
      NAME: "Twin Peaks Wilderness",
      "MANAGEMENT AREA": "Uinta-Wasatch-Cache National Forest",
      Address: "Cottonwood, UT 84121, United States",
      "Phone No:": "801-236-3400",
      Website:
        "https://www.fs.usda.gov/detail/uwcnf/about-forest/districts/?cid=fsem_035482",
      "Established on": "1984",
    },
    {
      NAME: "Wellsville Mountains Wilderness",
      "MANAGEMENT AREA": "Uinta-Wasatch-Cache National Forest",
      Address: "Mendon, UT 84325, United States",
      "Phone No:": "801-999-2103",
      Website:
        "https://www.fs.usda.gov/detail/uwcnf/recreation/wintersports/?cid=fsem_035479",
      "Established on": "1984",
    },
  ];
  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-b from-blue-50 to-white">
      {/* Landing Section */}
      <LandingSection
        data={{
          imageName: "service.webp",
          title: "US Forest Service Wilderness Areas",
        }}
      />

      {/* Main Content */}
      <div className=" mx-auto  py-12 w-full">
        {/* Intro Section */}
        <div className="text-center mb-12">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-blue-900 mb-2">
            Utah's US Forest Service Wilderness Areas
          </h1>
          <p className="text-xl text-blue-700">
            Explore untouched wilderness managed by the U.S. Forest Service
          </p>
        </div>

        {/* Parks Table */}
        <div className="flex items-center justify-center">
          <div className="bg-white rounded-xl  shadow-[0_4px_12px_0_rgba(1,76,178,0.3)] overflow-hidden w-[95%]">
            <div className="overflow-x-auto">
              <table className="min-w-full ">
                <thead className="bg-gradient-to-r from-blue-50 to-blue-100">
                  <tr>
                    <th className="px-6 py-4 text-center text-[20px] font-bold text-blue-800 tracking-wider">
                      Name
                    </th>
                    <th className="px-6 py-4 text-center text-[20px] font-bold text-blue-800 tracking-wider">
                      Management Area
                    </th>
                    <th className="px-6 py-4 text-center text-[20px] font-bold text-blue-800 tracking-wider">
                      Contact
                    </th>
                    <th className="px-6 py-4 text-center text-[20px] font-bold text-blue-800 tracking-wider">
                      Website
                    </th>
                    <th className="px-6 py-4 text-center text-[20px] font-bold text-blue-800 tracking-wider">
                      Established
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white">
                  {parks.map((park, index) => (
                    <tr
                      key={index}
                      className="hover:bg-blue-50 transition-colors"
                    >
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm text-center font-bold text-blue-900">
                          {park.NAME}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm text-center font-bold text-blue-900">
                          {park["MANAGEMENT AREA"]}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm text-center font-bold text-blue-900">
                          {park["Phone No:"]}
                        </div>
                        <div className="text-sm text-center font-bold text-blue-900">
                          {park.Address}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-center">
                        <a
                          href={park.Website}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-600 font-bold hover:text-blue-800 hover:underline"
                        >
                          Visit Website
                        </a>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-center font-bold text-blue-900">
                        {park["Established on"]}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default PlacesForestService;
